import { render } from "./MeetingManagement.vue?vue&type=template&id=23df3ba1"
import script from "./MeetingManagement.vue?vue&type=script&lang=js"
export * from "./MeetingManagement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__